<template>
  <div class="header">
    <img src="@/assets/images/jiariLogo.png" alt="" class="jiariLogo">
    <div class="nav">
      <router-link to="/" tag="div" class="logo" active-class="actives" exact><div>首页 </div></router-link>
      <router-link to="/course" tag="div" class="logo" active-class="actives"><div>线上课程</div></router-link>
      <router-link to="/serve" tag="div" class="logo" active-class="actives"><div>校园服务</div></router-link>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
   components: {},
   props: {},
   data () {
   return {
   };
   },
   watch: {},
   computed: {},
   methods: {},
   mounted () {
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue